"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useKeyPress = _interopRequireDefault(require("../useKeyPress"));

var _focusOnElement = _interopRequireDefault(require("../../helpers/focusOnElement"));

var _backwardNavigation = _interopRequireDefault(require("../../helpers/backwardNavigation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable complexity, sonarjs/cognitive-complexity */
function setFocus(logo, navLevel, setNavLevel, showSearch, setShowSearch, activeNav, activeSubNav, sideNavigationCloseButton, navTree, setNavTree, setIsTransitioning, setActiveSubNav, animationDuration, secondaryNav) {
  var keyPress = (0, _useKeyPress["default"])();
  (0, _react.useEffect)(function () {
    if (activeNav) {
      (0, _focusOnElement["default"])(activeNav.links[0].id);
    }
  }, [activeNav]);
  (0, _react.useEffect)(function () {
    if (activeSubNav) {
      (0, _focusOnElement["default"])(activeSubNav.links[0].id);
    }
  }, [activeSubNav]);
  (0, _react.useEffect)(function () {
    var _document$activeEleme;

    if (!keyPress) return; // Reset everything on Escape

    if (keyPress.key === 'Escape') {
      (0, _focusOnElement["default"])(logo.id);

      if (showSearch) {
        setNavLevel(0);
        setShowSearch(false);
        setTimeout(function () {
          (0, _focusOnElement["default"])(secondaryNav.search.id);
        }, animationDuration / 2);
      }

      if (navLevel > 0) {
        setNavLevel(0);
        setShowSearch(false);
        (0, _focusOnElement["default"])(activeNav.parentId);
      }
    }

    if (keyPress.key === 'Tab' && !(keyPress !== null && keyPress !== void 0 && keyPress.shiftKey) && sideNavigationCloseButton && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.id) === sideNavigationCloseButton.id) {
      keyPress === null || keyPress === void 0 ? void 0 : keyPress.preventDefault();
      (0, _focusOnElement["default"])(activeNav.parentId);
      setNavLevel(0);
    } // Shift + Tab on the top item


    if (keyPress.shiftKey && keyPress.key === 'Tab') {
      var _document$activeEleme2, _document$activeEleme3;

      if (activeNav && ((_document$activeEleme2 = document.activeElement) === null || _document$activeEleme2 === void 0 ? void 0 : _document$activeEleme2.id) === activeNav.links[0].id) {
        keyPress === null || keyPress === void 0 ? void 0 : keyPress.preventDefault();
        (0, _focusOnElement["default"])(activeNav.parentId);
        setNavLevel(0);
      }

      if (activeSubNav && ((_document$activeEleme3 = document.activeElement) === null || _document$activeEleme3 === void 0 ? void 0 : _document$activeEleme3.id) === activeSubNav.links[0].id) {
        if (activeSubNav.level === 2) {
          keyPress === null || keyPress === void 0 ? void 0 : keyPress.preventDefault();
          (0, _focusOnElement["default"])(activeSubNav.parentId);
          setNavLevel(1);
        }

        if (activeSubNav.level > 2) {
          keyPress === null || keyPress === void 0 ? void 0 : keyPress.preventDefault();
          (0, _backwardNavigation["default"])(navLevel, navTree, setIsTransitioning, setNavLevel, setActiveSubNav, setNavTree, animationDuration);
          (0, _focusOnElement["default"])(activeSubNav.parentId);
        }
      }
    }
  }, [keyPress]);
}

var _default = setFocus;
exports["default"] = _default;
//# sourceMappingURL=setFocus.js.map